export const humanize = (key: string) => key.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());

export const dateTime = (iso: string | null) =>
  iso ? new Date(iso).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';

export const todayIso = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome' }).format(new Date());

/** Un nome di persona scritto tutto in maiuscolo, come nei registri, con le iniziali maiuscole: «Carlucci Sante». */
export const personName = (s: string) =>
  s === s.toUpperCase() && /\p{Lu}{2}/u.test(s)
    ? s.toLowerCase().replace(/(^|[\s'’-])(\p{L})/gu, (_, a: string, b: string) => a + b.toUpperCase())
    : s;

/** Solo la data, con l'anno: «08/01/2026». Accetta anche «2026-01-08». */
export const dateOnly = (iso: string | null | undefined) => (iso ? new Date(iso.length === 10 ? `${iso}T12:00:00` : iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—');
